import { createApp } from "vue";
import { createPinia } from "pinia";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "./style.css";
import App from "./App.vue";
import router from "./router";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate' // 引入插件
import { initLazyLoad, vLazy } from './utils/lazyLoad' // 懒加载工具

const app = createApp(App);

// 创建 Pinia 实例
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate)
app.use(pinia);
app.use(ElementPlus, {
  locale: zhCn,
});
app.use(router);

// 注册全局指令
app.directive('lazy', vLazy)

// 初始化懒加载
initLazyLoad()

// 初始化视口高度变量 (解决移动端地址栏问题)
const setViewportHeight = () => {
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}
setViewportHeight()
window.addEventListener('resize', setViewportHeight)

// 性能监控 (开发环境)
if (import.meta.env.DEV) {
  // 监听页面性能指标
  if ('PerformanceObserver' in window) {
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        console.log(`⚡ Performance: ${entry.name} - ${entry.duration.toFixed(2)}ms`)
      }
    })
    observer.observe({ entryTypes: ['measure', 'navigation'] })
  }
}

app.mount("#app");
